import { httpApi } from "./http.api";

export interface Address {
    uuid: string;
    address_string: string;
    floor: string;
    building: string;
    unit_type: string;
    street_unit: string;
    street_number: string;
    street_alpha: string;
    street_name: string;
    street_type: string;
    street_direction: string;
    suburb: string;
    city: string;
    postcode: string;
    network_type: string;
    category: string;
    hyper_fibre_available: boolean;
    service_available: number;
    source: string;
}

export interface Plan {
    uuid: string;
    plan_id: string;
    name: string;
    type: string;
    sub_title: string | null;
    description: string | null;
    upload: number;
    download: number;
    category: string;
    option_1: string | null;
    option_2: string | null;
    option_3: string | null;
    option_4: string | null;
    option_5: string | null;
    data_type: string;
    data_cap: number | null;
    cap_cost: string | null;
    cap_cost_inc_gst: string | null;
    unlimited_cost: string | null;
    unlimited_cost_inc_gst: string | null;
    allow_byo: boolean;
    hyper_fibre_required: number;
    fine_print: string | null;
    recommended: boolean;
    source: string;
    devices: Device[];
}

export interface Device {
    uuid: string;
    device_id: string;
    name: string;
    model_no: string;
    description: string | null;
    image_url: string;
    device_type: string;
    type: string;
    cost_device: string;
    cost_device_inc_gst: string;
    cost_shipping: string;
    cost_shipping_inc_gst: string;
    cost_type: string | 'one-off' | 'monthly';
    cost_term: number;
    option_1: string | null;
    option_2: string | null;
    option_3: string | null;
    option_4: string | null;
    option_5: string | null;
    fine_print: string | null;
    recommended: boolean;
}

// Keep Router interface for backward compatibility
export interface Router {
    uuid: string;
    router_id: string;
    name: string;
    type: string;
    model_no: string;
    description: string | null;
    cost_device: number;
    cost_shipping: number;
    cost_type: string | 'one-off' | 'monthly';
    cost_term: number;
    option_1: string | null;
    option_2: string | null;
    option_3: string | null;
    option_4: string | null;
    option_5: string | null;
    fine_print: string | null;
}

interface LaravelPaginationLink {
    url: string | null;
    label: string;
    active: boolean;
}

interface AddressResponse {
    current_page: number;
    data: Address[];
    first_page_url: string;
    from: number;
    last_page: number;
    last_page_url: string;
    links: LaravelPaginationLink[];
    next_page_url: string | null;
    path: string;
    per_page: number;
    prev_page_url: string | null;
    to: number;
    total: number;
}

interface PlansResponse {
    success: boolean;
    plans: Plan[];
}

export const searchAddress = async (query: string, page: number = 1): Promise<AddressResponse> => {
    const params = { query: query, per_page: 10, page: page };
    return await httpApi.get<AddressResponse>(`/address/search`, { params }).then(({ data }) => data);
};

export const getPlans = async (uuid: string, source?: string): Promise<PlansResponse> => {
    const url = source ? `/address/${uuid}/plans?source=${source}` : `/address/${uuid}/plans`;
    const response = await httpApi.get<Plan[]>(url);
    return {
        success: true,
        plans: response.data
    };
};
